module.exports = __webpack_public_path__ + "static/media/doctor.7d9e3d15.jpg";